<template>
	<div class="card" :class="{ 'padding-right': !!icon, 'subscription': isSubscription }">
		<span class="poppins" :class="{ 'grey--text lighten-3': isSubscription, 'text-bold': isRestHome }">
			{{ name }}
		</span>
		<div v-if="showRestHome && item.restHome && !isRestHome" class="extra-info text-bold">
			{{ item.restHome.name }}
		</div>
		<div v-if="showInitialDate && item.initialDate" class="extra-info grey--text lighten-3">
			Início: {{ item.initialDate | formatDate('DD/MM/YYYY') }}
		</div>
		<v-tooltip v-if="icon" bottom>
			<v-icon slot="activator" small>{{ icon.name }}</v-icon>
			<span>{{ icon.text }}</span>
		</v-tooltip>
	</div>
</template>

<script>
import moment from 'moment';
import { getStatusBox } from '@Consts/status-box';
import mixin from './mixin';

export default {
	name: 'Card',
	mixins: [mixin],
	props: {
		item: {
			type: Object,
			required: true
		},
		showRestHome: {
			type: Boolean,
			required: true
		},
		showInitialDate: {
			type: Boolean,
			required: true
		},
		date: {
			type: String,
			required: true
		},
		filters: {
			type: Object,
			default: () => ({})
		}
	},
	data: () => ({}),
	computed: {
		name() {
			let name = this.item.name;
			if (this.isRestHome)
				name += ` (${this.item.items.length})`;
			return name;
		},
		isRestHome() {
			return !!this.item.items;
		},
		isSubscription() {
			return !this.item.id;
		},
		done() {
			return this.isDone(this.item.status);
		},
		ready() {
			return this.isReady(this.item.status);
		},
		behind() {
			return this.isBehind(this.item.status);
		},
		icon() {
			if (!this.filters.department.step || !this.item.status || this.ready)
				return null;
			if (this.done) {
				return {
					name: 'fas fa-check',
					text: 'Pronto'
				};
			}
			if (this.behind) {
				return {
					name: 'fas fa-lock',
					text: getStatusBox(this.item.status)
				};
			}
			if (moment().format('YYYY-MM-DD') > moment(this.date).format('YYYY-MM-DD')) {
				return {
					name: 'fas fa-exclamation-triangle',
					text: 'Atrasado'
				};
			}
			return null;
		}
	}
};
</script>

<style lang="scss" scoped>
	::v-deep.card {
		position: relative;
		background: #eee;
		margin-top: 4px;
		border-radius: 4px;
		padding: 2px 4px;
		width: 100%;

		&.padding-right {
			padding-right: 32px;
		}

		.poppins {
			display: inline-block;
			font-size: 12px;
			line-height: 14px;
		}

		.extra-info {
			font-size: 12px;
		}

		.v-icon {
			width: 24px;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 4px;
		}
	}
</style>
